module.exports = __webpack_public_path__ + "img/history-bg.d6220d1c.jpg";